'use client';

import { useLocale } from 'next-intl';
import { useSession } from './session/provider';
import { toIntlLocale } from './i18n/intlLocale';

const useUserData = () => {
  const { userData } = useSession();
  const locale = toIntlLocale(useLocale());

  return {
    role: userData?.role,
    plan: userData?.plan,
    currency: 'CLP',
    locale,
    isAdmin: userData?.role === 'admin',
    isUser: userData?.role === 'user',
  };
};

export default useUserData;
